import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete, TextField } from '@mui/material';
import { setSelectedLocation, setLocations } from 'redux/actions/LocationDropdown';
import { getServiceCity } from 'redux/actions/UserServiceCity';// Assuming this is the correct import path

function LocationDropdown({ onChange, className = "", enabledefaultCity = null, value, placeholder= "All City" }) {
  const dispatch = useDispatch();
  const locations = useSelector((state) => state?.locationDropdown?.locations || []);
  const selectedLocation = useSelector((state) => state?.locationDropdown?.selectedLocation);
  const userProfileData = useSelector((state) => state?.userProfile?.userProfile?.data);
  const Location = useSelector((state) => state?.userServiceCity?.userServiceCity?.data);
  const defaultCityApplied = useRef(false);

  useEffect(() => {
    // If Location data is not available, fetch it
    if (!Location || Location.length === 0) {
      dispatch(getServiceCity());
      return;
    }
    
    if (locations.length === 0 && Location?.length > 0) {
      dispatch(setLocations(Location));
    }
    
    // Set default location based on different conditions
    if (!selectedLocation && Location?.length > 0) {
      if (userProfileData?.Company?.ServiceCity?.id) {
        // Find the matching city from Location array
        const companyCity = Location.find(
          city => city.id === userProfileData.Company.ServiceCity.id
        );
        if (companyCity) {
          dispatch(setSelectedLocation(companyCity));
        }
      } else if (userProfileData?.region) {
        dispatch(setSelectedLocation(Location[0]));
      }
    }

    // Clear selected location if it doesn't exist in locations (for non-region users)
    if (!userProfileData?.region && selectedLocation && locations.length > 0) {
      const locationExists = locations.find(loc => loc.id === selectedLocation.id);
      if (!locationExists) {
        dispatch(setSelectedLocation(null));
      }
    }

    if (enabledefaultCity && !defaultCityApplied.current) {
  const defaultCity = Location.find(city => city.name === "Bengaluru");
  if (defaultCity) {
    dispatch(setSelectedLocation(defaultCity));
    if (onChange) {
      onChange(defaultCity);
    }
    defaultCityApplied.current = true; // Mark it as applied
  }
}
  }, [dispatch, locations, Location, selectedLocation, userProfileData]);

  const handleLocationChange = (event, newValue) => {
  dispatch(setSelectedLocation(newValue));
  if (onChange) {
    onChange(newValue);
  }
  if (newValue === null) {
    defaultCityApplied.current = true; // Prevent default reset
  }
};

  // Common sx styling
  const commonSx = {
    '& .MuiInputBase-root': {
      height: '40px',
      padding: '0 8px',
    },
    '& .MuiOutlinedInput-root': {
      paddingRight: '39px !important',
    },
    width: '100%',
    '& .MuiAutocomplete-input': {
      padding: '7.5px 4px !important',
    }
  };

  // Case 1: Fixed company service city
  if (userProfileData?.Company?.ServiceCity?.id) {
    const companyCity = Location?.find(
      city => city.id === userProfileData.Company.ServiceCity.id
    );
    return (
      <div>
        <TextField
          className={`customDefaultValue ${className}`}
          size="small"
          disabled={true}
          value={companyCity?.name || userProfileData?.Company?.ServiceCity?.name || ''}
          sx={commonSx}
        />
      </div>
    );
  }

  // Case 2: User with region
  if (userProfileData?.region) {
    return (
      <div>
        <Autocomplete
          value={Location?.find(city => city?.id === selectedLocation?.id) || (Location?.length > 0 ? Location[0] : null)}
          size="small"
          onChange={handleLocationChange}
          id="city-selection-autocomplete"
          getOptionLabel={(option) => option?.name || ''}
          options={Location || []}
          filterOptions={(options) => options}
          clearOnBlur={false}
          className={className}
          disableClearable
          disablePortal
          sx={commonSx}
          ListboxProps={{
            style: {
              maxHeight: "150px",
            },
          }}
          renderInput={(params) => (
            <TextField {...params} inputProps={{ ...params.inputProps, readOnly: true }} />
          )}
        />
      </div>
    );
  }

  // Case 3: Default dropdown
  return (
    <div>
      <Autocomplete
        value={selectedLocation}
        size="small"
        onChange={handleLocationChange}
        id="default-city-selection"
        getOptionLabel={(option) => option?.name || ''}
        options={Location || []}
        className={className}
        sx={commonSx}
        renderInput={(params) => (
          <TextField {...params} placeholder={placeholder} />
        )}
        ListboxProps={{
          style: {
            maxHeight: "150px",
          },
        }}
      />
    </div>
  );
}

export default LocationDropdown;